// Recovered compiled webpack factory 62213. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { q: () => n });
  let n = { layout: 0, mainThread: 0, waapi: 0 };
}
